<template>
    <div class="app-box">
       <sensodyne/>
    </div>
</template>

<script setup>
import { ref } from 'vue';
// import ProductViewer from '@/components/ProductViewer.vue'
import sensodyne from '@/components/products/sensodyne/list.vue'

</script>

<style lang="scss" scoped>
.app-box {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    .ar-scan-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 9;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .ar-mindar-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 8;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .model-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 10;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .bg-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 9;
        left: 0;
        right: 0;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .ysc {
        user-select: none;
        pointer-events: none;
        background-image: url('/img/bg-sc.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        object-fit: cover;
    }

    .effect-box {
        width: 100vw;
        height: 90vh;
        position: absolute;
        z-index: 10;
        left: 0vw;
        right: 0vw;
        overflow: hidden;

    }

    .product-ui-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        overflow: hidden;
        z-index: 11;
        left: 0;
        right: 0;
        user-select: none;
        pointer-events: none;

    }

    .model-control {
        width: 100vw;
        height: 100vh;
        user-select: none;
        pointer-events: none;
        z-index: 10;
        left: 0;
        right: 0;
        position: absolute;
        overflow: hidden;
    }
}

.bg-mask {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
}

.move-up {
    animation: move-up 0.6s;
    animation-fill-mode: forwards;
}

@keyframes move-up {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>